function normalizeOperatorAction(action: string): string {
  return action.trim().toLowerCase().replace(/-/g, '_')
}

export function canGenerateDraftFromMessage(
  messageStatus: string,
  operatorActions?: string[] | null,
): boolean {
  void messageStatus

  // 前端消息操作按钮只看 operator_actions，避免旧状态兜底掩盖真实 API 契约缺口。
  if (!Array.isArray(operatorActions)) {
    return false
  }

  return operatorActions.some((action) => normalizeOperatorAction(action) === 'generate_draft')
}
